module.exports = __webpack_public_path__ + "media/images/user-card-826b4247b06491bdbb28a9035d4eb9e2.svg";